module.exports = __webpack_public_path__ + "ce03e0b7a60424ea72062f841ae39adc.jpg";